import { StudentLayout } from '@/components/layout/student'
import { StudentRequestContent } from '@/components/layout/student/request-content'
import { useStudentSessionStore } from '@/store/student-session-store'
import { ExternalTransferPreviousEducationData } from '../../../components/student/transfer-steps/step-1/external-transfer-previous-education-data'
import { CheckTheEquivalences } from '../../../components/student/transfer-steps/step-2/check-the-equivalences'
import { useStudentExternalTransferForms } from './hooks/use-student-external-transfer-form'
import { useSubmitStudentRequestsForm } from './hooks/use-submit-request-form'

export const StudentExternalTransferPage = () => {
  const requestLabel = 'Transferência Externa'

  const {
    states: { formMethods, formMethodsIA }
  } = useStudentExternalTransferForms()

  const { courseName } = useStudentSessionStore()

  const {
    states: {
      currentStep,
      fileStatus,
      isPreviousEducationSavePending,
      isCourseEquivalencePending,
      isCourseEquivalenceSuccess,
      request,
      isPendingEquivalences,
      fileWarning,
      hasAutomaticEquivalences
    },
    actions: { handleBack, handleNext, uploadMutate }
  } = useSubmitStudentRequestsForm(formMethods, formMethodsIA)

  const steps = [
    {
      label: 'Curso Anterior',
      content: (
        <ExternalTransferPreviousEducationData
          requestLabel={requestLabel}
          fileStatus={fileStatus}
          formMethods={formMethods}
          uploadMutation={uploadMutate}
          request={request}
          fileWarning={fileWarning}
        />
      ),
      pendingSave: isPreviousEducationSavePending
    },
    {
      label: 'Disciplinas a Dispensar',
      content: (
        <CheckTheEquivalences
          formMethods={formMethods}
          formMethodsAI={formMethodsIA}
          isPendingEquivalenceGenerate={isPendingEquivalences}
          isPendingSubmit={isCourseEquivalencePending}
          fileStatus={fileStatus}
          isSuccessSubmit={isCourseEquivalenceSuccess}
          request={request}
          hasAutomaticEquivalences={hasAutomaticEquivalences}
        />
      ),
      pendingSave: isCourseEquivalencePending
    }
  ]

  return (
    <StudentLayout>
      <StudentRequestContent
        requestTitle={requestLabel}
        requestSubTitle="Curso de transferência"
        steps={steps}
        currentStep={currentStep}
        handleNext={handleNext}
        fileStatus={fileStatus}
        handleBack={handleBack}
        request={request}
        disabledButtons={
          isPendingEquivalences
          || isCourseEquivalencePending
          || isCourseEquivalenceSuccess
        }
        transferCourse={courseName || ''}
        finishedTransfer={isCourseEquivalenceSuccess}
      />
    </StudentLayout>
  )
}
